export const BUILDING_FORM_BUILDING_TYPE_API_PARAMS = {
  ordering: 'value',
}
